import Action from 'actions';
import Const from 'constants';
import BaseLineup from 'services/sports/default/base-lineup';

export default class Lineup extends BaseLineup {
    getValidationRules({defaultValue = {}, ...rest}) {
        const {stacks, playersData, playersLock} = Action.getState();

        return {
            lockedPlayers: playersLock.getMergedLockedPlayerIds(),
        };
    }
}
